import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import FullTable from "components/FullTable"
import _ from 'lodash'
import { Link } from 'react-router-dom'
import clone from 'clone'
import helpers from 'helpers/helpers'


class SubdivisionManagement extends Component {

	constructor(props) {
		super(props)

		this.state = {
			columns: [
				{
					Header: "Subdivision",
					accessor: "name",
					filterMethod: (f, r) => helpers.tableText(f, r, "name"),
				},
				{
					Header: "Code",
					accessor: "code",
					filterMethod: (f, r) => helpers.tableText(f, r, "code"),
				},
				{
					Header: "Community",
					accessor: "property",
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},

				{
					Header: "Edit",
					accessor: "edit",
				},
			],
		}
	}

	buildTable = type => {
        let data = []
		_.forEach(this.props.payload.public.subdivisions, v => {
			if(!this.props.activeProperties.includes(v.property)) {
				return
			}
			let p = clone(v)
			let property = _.find(this.props.payload.public.properties, {id: v.property})
			if(property) {
				p.property = property.name
			}

			p.edit = (
                <Link to={`/admin/subdivisions/${p.id}`}>
                    <i className="far fa-edit"></i>
                </Link>
            )
			data.push(p)
		})
		return data
    }

	render() {
		
		if(this.props.payloadStatus){
			return (
				<div className="admin">
					<Title title="Subdivision Management" showDate={false} />
					<div className="content">
						<div className="admin__add">
							<Link to={"/admin/subdivisions/add"}>
								<i className="fas fa-plus-circle" />
							</Link>
						</div>
						<FullTable
							data={this.buildTable()}
							columns={this.state.columns}
							name="subdivisions"
							title="Subdivisions"
							unset={["edit"]}
							pageSize={20}
							defaultSorted={[
								{
									id: "name",
									asc: true,
								},
							]}
						/>
					</div>
				</div>
			)
		}
		else {
			return('')
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(SubdivisionManagement)
